export default "__VITE_ASSET__4a8713da__"